import React from 'react'

const ContactUs = () => {
  return (
    <div style={{marginTop:"80px"}}>ContactUs</div>
  )
}

export default ContactUs